import { useQuery } from 'react-query';

import axiosClient from '@lib/utils/axiosClient';
import { TPath } from '../types';
import { mapSelectToScreenQuery } from '../mapSelectToScreenQuery';

const fetchEntityCount = async ({ queryKey }: { queryKey: string[] }) => {
  const [path] = queryKey;
  const response = await axiosClient.get(path);
  return response.data;
};

export function useEntityCount(path: TPath, stringParams?: string, enabled: boolean = true) {
  const params = stringParams ? `?${stringParams}` : '';
  return useQuery(`/${path}/count${params}`, fetchEntityCount, {
    select: mapSelectToScreenQuery,
    enabled,
  });
}
